import { recentFiles } from "./file-manager";
import { ordersData } from "./order";
import { customersData } from "./customer";
import { cartData } from "./cart";
import { projectData } from "./projectdata";
import { userGridData } from "./usergrid";
import { userList } from "./userlist";
import { JobListdata } from "./joblist";
import { JobGriddata } from "./jobgrid";
import { CandidateList } from "./candidate";
import { listData } from "./invoices";
import { chatData, chatMessagesData } from "./chat";
import { JobApplydata } from "./jobapply";
import { memberList, tasks } from "./kanban";
import { orders } from "./cryptoOrder";
import { emailData } from "./email";

export { orders, memberList, tasks, recentFiles, ordersData, customersData, cartData, projectData, userGridData, userList, JobListdata, JobGriddata, CandidateList, listData, chatMessagesData, chatData, JobApplydata, emailData }